/* eslint-disable react-hooks/exhaustive-deps */
import { Button, ButtonVariant, Icon, Size } from "@blueprintjs/core"
import { useEffect, useState } from "react"
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd"
import { DIALOG_SIZE, HasId } from "src/libs/interfaces/layouts"
import IScalarForm from "src/libs/scalars/interface/IScalarForm"
import SubMenu from "src/libs/scalars/SubMenu"
import { Pagi, ScalableDialog } from "src/libs/useful"
import { __, __cases } from "src/libs/utilities"
import { IState, useMainStore } from "src/settings/zustand"
import LandingCompositeContent from "."
import createBySchema from "../../data/utils/createBySchema"
import { AddBtn } from "./AddBtn"

/* Protopia Ecosystem component */
export interface ILandingCompositeFeedProps {
    title?: string
    subMenus?: IScalarForm[] | undefined
    onSubmenu: (() => void) | undefined
    origin?: any
    component?: any
    isAlwaysOpen?: boolean
    schemaType: any
    value: any[]
    isDeleted?: boolean
    dataName: string
    dataSection: string
    onChange: ( _value: any, field: string, data: any, type: string ) => void
    onValue: ( value: any[] ) => void 
}
const LandingCompositeFeed = (props: ILandingCompositeFeedProps): JSX.Element => {
    const [value, setValue] = useState<any[]>( props.value ) 
    useEffect(() => {
        setValue( props.value )
    }, [ props.value ])

    const onChange = ( _value: any, field: string, data: any, type: string ) => {
         props.onChange( _value, field, data, type ) 
    } 

    return <div className="my-2"> 
        <SubMenu
            subMenus={props.subMenus}
            on={props.onSubmenu}
        />
        <div className="title small mt-3 mb-1 px-3 col-md-12 pointer">{ __( props.title || "" ) }</div>
        {
            value.length > 10
                ?
                <FeedListModal { ...props } onChange={onChange} />
                :
                <FeedList { ...props } onChange={onChange} />
        }
    </div> 
}
export default LandingCompositeFeed

const FeedListModal = ( props: ILandingCompositeFeedProps ): JSX.Element => { 
    const [isOpen, seIsOpen] = useState<boolean>( false )
    
    const onChange = ( _value: any, field: string, data: any, type: string ) => {
         props.onChange( _value, field, data, type ) 
    }
    const onOpen = ( evt: any, val : boolean = true ) => {
        seIsOpen( val )
    }

    return <>
        <Button variant={ ButtonVariant.MINIMAL } size={ Size.LARGE} fill className="mx-3 p-4" onClick={ onOpen }>
            { __( "see all" ) } { props.value.length } { __cases( props.value.length, "elements" )}
        </Button>
        <ScalableDialog
            isOpen={ isOpen }
            onClose={ () => onOpen( null, false ) }
            dialogSize={ DIALOG_SIZE.NORMAL }
            isCloseButtonShown={ true }
            hideClose={ false }
            isControlOutside
        > 
            <div className="max-height overflow-y-auto">
                <div className="p-4">
                    <FeedList { ...props } value={ isOpen ? props.value : [] } onChange={onChange} />
                </div>
            </div>
        </ScalableDialog>
    </>
}
const FeedList = ( props: ILandingCompositeFeedProps ): JSX.Element => {
    const setPage = (current: number ) => {
        return props.value.filter((__, i) => pageCount + ( current * pageCount ) && i < pageCount + ( current * pageCount ) + pageCount )
    }
    const pageCount = useMainStore(( state: IState ) => state.pageCount)
    const [current, setCurrent] = useState<number>( 0 )
    const [value, setValue] = useState<any[]>( setPage( 0 ) )
    useEffect(() => {
        setValue( setPage( current ) )
    }, [ props.value ])

    const onAdd = ( type: string, n: number ) => { 
        const newVal = [...value, createBySchema( type )]
        // console.log( "add composite", type, n, props.dataName, newVal, props )
        props.onChange( newVal, "", {}, "" ) 
    }
    
    const onRemove = ( item: HasId ) => {
        const newVal = [ ...value ].filter( it => it.id !== item.id )
        props.onChange( newVal, "", {}, "" ) 
    }

    const getOrigin = (val:any, i: number) => {
        const obj = !!props.origin 
            ?  
            !!props.origin[ val.type || props.component ] 
                ? 
                props.origin[ val.type || props.component ]
                :
                !!props.origin.data
                    ?
                    props.origin.data[i]
                    :
                    {}
            : 
            {} 
        // console.log( i, val.type || props.component, props.origin ) 
        // console.log( obj ) 
        return obj
    }

    // a little function to help us with reordering the result
    const reorder = (list: any[], startIndex: number, endIndex: number) => {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed); 
        return result;
    }; 

    const getItemStyle = (isDragging: boolean, draggableStyle: any) => ({ 
        userSelect: "none",
        display: "flex",
        alignItems: "center",
        padding: 0,
        margin: `0 0 3px 0`, 
        width: "100%",
        // change background colour if dragging
        background: isDragging ? "#a4bcf0" : "transparent", 
        color: isDragging ? "#d1ddf5" : undefined, 
        // styles we need to apply on draggables
        ...draggableStyle
    });

    const getListStyle = (isDraggingOver: boolean) => ({
        background: isDraggingOver ? "#8885b4cc" : "transparent",
        color: isDraggingOver ? "#5e7092" : undefined, 
        padding: 0, 
    })
    const onDragEnd = (result: any) => {
        // dropped outside the list
        if (!result.destination) {
            return;
        } 
        const _items: any[] = reorder(
            value,
            result.source.index,
            result.destination.index
        ); 
        //setValue(_items )
        props.onChange( _items, "", "", "" )
    }
    const onPage = ( i: number) => {
        setCurrent( i )
        setValue( setPage( i ) )
    }
    return <>
        <DragDropContext onDragEnd={ onDragEnd }>
            <Droppable droppableId="droppable">
                {(provided, snapshot) => (
                    <div
                        {...provided.droppableProps}
                        ref={provided.innerRef}
                        style={getListStyle(snapshot.isDraggingOver)}
                    >
                        { 
                            value.map((val: any, i: number) => {
                                return <div key={val.id} className="d-flex"> 
                                    <Draggable draggableId={ val.id } index={ i }>
                                        {(provided, snapshot) => {
                                            let required = !!props.schemaType.required   
                                            return <div
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                                {...provided.dragHandleProps}
                                                style={getItemStyle(
                                                    snapshot.isDragging,
                                                    provided.draggableProps.style
                                                )}
                                            > 
                                                <div className="w-100"> 
                                                    <LandingCompositeContent 
                                                        children={ <Icon icon="drag-handle-vertical" className="px-2" /> }
                                                        isAlwaysOpen={ props.isAlwaysOpen }
                                                        val={{ ...val }}
                                                        value={props.value}
                                                        onValue={ ( _value: any ) => props.onValue(_value) }
                                                        required={required}
                                                        type={ val.type || props.component }  
                                                        component={ val.type || props.component }  
                                                        isDeleted={ props.isDeleted }
                                                        dataName={props.dataName}
                                                        schemaType={props.schemaType}
                                                        dataSection={props.dataSection}
                                                        origin={  getOrigin( val, i ) }
                                                        i={ i } 
                                                        length={ props.value.length }
                                                        onChange={ ( value: any, field: string, data: any ) => props.onChange( value, field, data, val.id ) }
                                                        onRemove={ onRemove }
                                                    />
                                                </div>
                                            </div>
                                        }}
                                    </Draggable>
                                </div>
                            })
                        }
                    </div>
                )}
            </Droppable >
        </DragDropContext>
        <Pagi
            all={ Math.floor( props.value.length / pageCount ) + 1 }
            current={ current }
            count={ pageCount }
            onChoose={ onPage }
        />
        <div className="container">  
            <AddBtn onAdd={ (type: string, n:number, ) => onAdd(type, n,  ) } component={ props.component || "----" } /> 
        </div>
    </>
}